import { useState } from 'react'
import type { Message } from '@/types/api'
import { canSelectForDeletion, MAX_BULK_DELETE, selectedMessages, toggleMessageSelection } from '@/lib/bulkDelete'

export function useMessageSelection(channelId: string, messages: readonly Message[], enabled: boolean) {
  const [state, setState] = useState({ channelId, enabled, active: false, ids: [] as string[], confirm: null as Message[] | null })
  // Смена канала и потеря прав сбрасывают выбор до отображения следующего кадра.
  if (state.channelId !== channelId || state.enabled !== enabled) setState({ channelId, enabled, active: false, ids: [], confirm: null })
  const active = state.channelId === channelId && enabled && state.active
  const chosen = active ? selectedMessages(messages, state.ids) : []
  const ids = new Set(chosen.map((m) => m.id))
  const finish = () => setState((s) => s.channelId === channelId ? { ...s, active: false, ids: [], confirm: null } : s)
  return {
    active, chosen, ids, availableCount: messages.filter(canSelectForDeletion).length,
    confirm: active ? state.confirm : null,
    start: () => setState({ channelId, enabled, active: true, ids: [], confirm: null }),
    select: (m: Message) => setState((s) => ({ channelId, enabled, active: true, ids: toggleMessageSelection(s.active ? chosen.map((m) => m.id) : [], m.id), confirm: null })),
    selectLoaded: () => setState((s) => ({ ...s, ids: messages.filter(canSelectForDeletion).slice(-MAX_BULK_DELETE).map((m) => m.id) })),
    clear: () => setState((s) => ({ ...s, ids: [] })),
    openConfirm: () => setState((s) => ({ ...s, confirm: [...chosen] })),
    closeConfirm: () => setState((s) => ({ ...s, confirm: null })),
    finish,
  }
}
